/**
 * Nominatim-based place search (via backend /api/places/suggest).
 * Used when Google Places is not configured.
 */

import { apiUrl } from '../../services/api';

/**
 * Search places via Nominatim (backend proxy).
 *
 * @param {string} query - Search query (min 2 chars)
 * @param {Object} [options]
 * @param {number} [options.limit=6]
 * @param {string} [options.lang='original']
 * @param {string[]} [options.countryCodes]
 * @param {AbortSignal} [options.signal]
 * @returns {Promise<Array>} Array of { label, display_name, subtitle, lat, lon, ... }
 */
export async function searchPlaces(query, options = {}) {
  const q = String(query || '').trim();
  if (q.length < 2) return [];

  const { limit = 6, lang = 'original', countryCodes, signal } = options;
  const params = new URLSearchParams({ q, limit: String(limit), lang: String(lang) });
  if (Array.isArray(countryCodes) && countryCodes.length > 0) {
    params.set('countrycodes', countryCodes.join(','));
  }

  const url = `${apiUrl('/api/places/suggest')}?${params.toString()}`;
  const res = await fetch(url, { signal });
  if (!res.ok) return [];

  const data = await res.json();
  return Array.isArray(data) ? data : [];
}
